
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[...slug]",
      function () {
        return require("private-next-pages/c/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[...slug]"])
      });
    }
  